import { notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import axios from "../../../../Services/axiosCommon";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dasboard from "../../../../Components/Icons/Dasboard";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { CountryMIN } from "../../../../assets/CountryMini";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NuDate, NuInput, NuLabel, NuMobileNumber, NuSelect, NuSelectwithSearch, NuTextArea, NuUpload, SupplierNuInput } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import DropDownAddCurrency from "../../../../Components/Utils/selectAddCurrencyDropDown";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import UseFetchCurrency from "../../../../Components/Hooks/useFetchCurrencyData";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";

const CreateSubCon = ({ open, getData, onCancel, data }) => {
  const {officeId} =useParams();

  const { value: desigination, getData: refdesigination } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination_Supplier"
  );
  const { value: subConType, getData: refsubConType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "subConType_Supplier"
  );
  const { value: conPeriod, getData: refconPeriod } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "conPeriod_Supplier"
  );
 
  const { value: supplierCat, getData: refsupplierCat } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "SupplierCategory"
  );
  const { value: vendorRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "vendorRating_supplier"
  );

  const [image, setImage] = useState({ preview: "", raw: "" });
  const [productList, setProductList] = useState([]);
  const productsString = productList.join(", ");
  const [servicesList, setServicesList] = useState([]);
  const servicesString = servicesList.join(", ");
  const [emailsList, setEmailsList] = useState([]);
  const emailsString = emailsList.join(", ");

    const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [createNew, setCreateNew] = useState({
    contactPerson: "",
    companyName: "",
    email: "",
    phone: "",
    countryCode: "",
    website: "",
    designation: "",
    buildingNo: "",
    contactPersonEmail: "",
    contactPersonMobile: "",
    taxId: "",   
    comments: "",
    streetName: "",
    country: "",
    city: "",
    state: "",
    district: "",
    postalCode: "",
    cpCountryCode: "",
    branchId:officeId,   
    performanceRating:"",
    subConType:"",
    category:"",
    subConNumber: "",
    title:"",
    scopeOfWork:"",
    conName:"",
    signedOn:"",
    conValue:"",
    conPeriod: "",
    startDate:"",
    endDate:"",
    renewedOn:"",
    renewable:"", 
    validUpto:"",
    terminationDate:"",
    terminationReason:"",
    amendmendRef:"",
    amendmendValue: "",
    totalConValue:"",
    address1:"",
    address2:""
    
   
  });
  console.log("list", productList);
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      phone: yup
        .string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Phone number is required"),
      contactPersonMobile: yup
        .string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Phone number is required"),
      email: yup.string().required("Email is required!"),
      companyName: yup.string().required("Company Name is required!"),
      // website: yup.string().required("Website is required!"),
      contactPerson: yup.string().required("Contact Person is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
          let formData = new FormData();
      const valueWithProducts = {
        ...value,
        renewable: value.renewable === "true",
      };
      formData.append("json_data", JSON.stringify(valueWithProducts));
      formData.append("attachments", image.raw);

      addFormData("/sub-con/", formData, resetForm);
          },
  });

  
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end mb-4">
        {/* <Breadcrumb
          items={[
            {
              name: "sub-con",
              link: `/main/${officeId}/contacts/sub-con`,
            },
            {
              name: "Create",
            },
          ]}
        /> */}
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-140px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto pb-4 bg-white rounded-md ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Company Details :
                </p>
              </div>
              <NuInput
                type="text"
                label="Company Name"
                placeholder="Company Name"
                formik={formik}
                name="companyName"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <DropDownAddMetaData
                label="Category"
                placeholder="Choose"
                Options={supplierCat}
                formik={formik}
                name="category"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refsupplierCat}
                displayProperty={"Category"}
                propertyName={"SupplierCategory"}
                 FixPosition={true}
                PortalTarget={false}
              />

              <NuMobileNumber
                nunCode="countryCode"
                label="Phone"
                placeholder="Phone"
                formik={formik}
                name="phone"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
                 FixPosition={true}
                PortalTarget={false}
              />
              <NuInput
                type="email"
                label="Email"
                placeholder="Email"
                formik={formik}
                name="email"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
              />

              <NuInput
                type="text"
                label="Website"
                placeholder="Website"
                formik={formik}
                name="website"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
          
              <NuInput
                type="number"
                label="Tax Id"
                placeholder="Tax Id"
                formik={formik}
                name="taxId"
                width="w-full md:w-1/2 lg:w-1/3"
              />


             
              <FormikSelectTwo
                Options={vendorRating}
                label="Performance Ratings"
                placeholder="Performance Ratings"
                formik={formik}
                name="performanceRating"
                width="w-full md:w-1/2 lg:w-1/3"
                 FixPosition={true}
                PortalTarget={false}
              />

              <NuUpload
                label="Image"
                width="w-full md:w-1/2 lg:w-1/3"
                onChange={handleChangeImg}
              />
  <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Sub-Contractor Details :
                </p>
              </div>
              <NuInput
                type="text"
                label="Title"
                placeholder="Title"
                formik={formik}
                name="title"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="text"
                label="Contractor Name"
                placeholder="Contractor Name"
                formik={formik}
                name="conName"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="number"
                label="Sub-Con Number"
                placeholder="Sub-Con Number"
                formik={formik}
                name="subConNumber"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <DropDownAddMetaData
                label="Sub-Con Type"
                placeholder="Choose"
                Options={subConType}
                formik={formik}
                name="subConType"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refsubConType}
                displayProperty={"Sub-Con Type"}
                propertyName={"subConType_Supplier"}
                 FixPosition={true}
                PortalTarget={false}
              />
               <NuDate
                            label="Signed On"
                            placeholder="Signed On"
                            formik={formik}
                            name="signedOn"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <NuInput
                type="number"
                label="Value"
                placeholder="Value"
                formik={formik}
                name="conValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <DropDownAddMetaData
                label="Sub-Con Period"
                placeholder="Choose"
                Options={conPeriod}
                formik={formik}
                name="conPeriod"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refconPeriod}
                displayProperty={"Sub-Con Period"}
                propertyName={"conPeriod_Supplier"}
                 FixPosition={true}
                PortalTarget={false}
              />
               <NuDate
                            label="Start Date"
                            placeholder="Start Date"
                            formik={formik}
                            name="startDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="End Date"
                            placeholder="End Date"
                            formik={formik}
                            name="endDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="Renewed On"
                            placeholder="Renewed On"
                            formik={formik}
                            name="renewedOn"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <FormikSelectTwo
                type="text"
                label="Renewable"
                placeholder="Choose"
                Options={[
                  {
                    value:'true',label:'True'
                  },
                  {
                    value:'false',label:'False'
                  }
                ]}
                formik={formik}
                name="renewable"
                width="w-full md:w-1/2 lg:w-1/3"
                 FixPosition={true}
                PortalTarget={false}
              />
               <NuDate
                            label="Valid Upto"
                            placeholder="Valid Upto"
                            formik={formik}
                            name="validUpto"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="Termination Date"
                            placeholder="Termination Date"
                            formik={formik}
                            name="terminationDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <NuInput
                type="text"
                label="Amendmend Reference"
                placeholder="Amendmend Reference"
                formik={formik}                
                name="amendmendRef"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="number"
                label="Amendmend Value"
                placeholder="Amendmend Value"
                formik={formik}
                name="amendmendValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="number"
                label="Total-Con Value"
                placeholder="Total-Con Value"
                formik={formik}
                name="totalConValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Contact Person Details :
                </p>
              </div>

              <NuInput
                type="text"
                label="Name"
                placeholder="Name"
                formik={formik}
                isRequired={true}
                name="contactPerson"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <DropDownAddMetaData
                label="Designation"
                placeholder="Choose"
                Options={desigination}
                formik={formik}
                name="designation"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refdesigination}
                displayProperty={"Designation"}
                propertyName={"desigination_Supplier"}
                 FixPosition={true}
                PortalTarget={false}
              />

              <NuMobileNumber
                nunCode="cpCountryCode"
                label="Contact Person Mobile"
                placeholder="Contact Person Mobile"
                formik={formik}
                isRequired={true}
                name="contactPersonMobile"
                width="w-full md:w-1/2 lg:w-1/3"
                 FixPosition={true}
                PortalTarget={false}
              />
              <NuInput
                type="email"
                label="Contact Person Email"
                placeholder="Contact Person Email"
                formik={formik}
                name="contactPersonEmail"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            </div>
          </div>
          <div className="w-full mx-auto pb-4 bg-white rounded-md  mt-4">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Address :
                </p>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="address1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="address2"
                width="w-full md:w-1/2 lg:w-1/3"
              />
<NuInput
                type="text"
                label="Building No"
                placeholder="Building No"
                formik={formik}
                name="buildingNo"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="city"
                width="w-full md:w-1/2 lg:w-1/3"
              />
 <NuInput
                type="text"
                label="District"
                placeholder="District"
                formik={formik}
                name="district"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="postalCode"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />

              <NuTextArea
                label="Scope of Work"
                placeholder="Scope of Work"
                formik={formik}
                name="scopeOfWork"
                width="w-full md:w-1/2 "
                // new_width="lg:w-1/2"
              />
               <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 "
                // new_width="lg:w-1/2"
              />
               <div className="w-full   mx-auto my-4 mt-8 ">
                <div className="flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
          
        </form>
      </div>
    </div>
  );
}
export default CreateSubCon;
